export default function handleImageStyleFormat(
  asBadges,
  isAllEgal,
  isRound,
  styles
) {
  if (asBadges) {
    if (isAllEgal) {
      return styles._badges;
    } else {
      return styles._badges_with_difference;
    }
  } else if (isRound) {
    return styles._rounded;
  } else {
    return "";
  }
}
